var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.103 15.107c.325.296.857.71.62 1.45-.236.74-1.626 2.514-4.051 2.13-2.425-.385-5.117-2.751-7.335-5.768S.7 6.649 1.054 4.224C1.41 1.799 3.746 1 4.337 1c.592 0 1.006.621 1.213 1.035l1.39 3.076a1.33 1.33 0 01-.621 1.715c-.888.503-2.307 1.095.207 4.525 2.514 3.431 3.49 2.219 4.259 1.538a1.33 1.33 0 011.804-.059l2.514 2.277z",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgPhoneIcon;